import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, NgForm, Validators, FormControl } from '@angular/forms';
import { HttpClient, HttpParams} from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { ProjectService } from 'src/app/_services/project.service';

@Component({
  selector: 'app-add-suite-module',
  templateUrl: './add-suite-module.component.html',
  styleUrls: ['./add-suite-module.component.scss']
})
export class AddSuiteModuleComponent implements OnInit {
  addTestModuleForm:UntypedFormGroup;
  updateTestModuleForm:UntypedFormGroup;
  projectName: any;
  submitted= false;
  url: string;
  title: any;
  projectId: any;
  parentTestDataId: any;
  dependent =false;
  önUpdate:boolean = false;
  onAdd:boolean = false;
  titleName: any;
  description: any;
  isModuleSelected: boolean;
  selectedModuleData: any;

 
  constructor(@Inject(MAT_DIALOG_DATA) public data,
  private formBuilder: UntypedFormBuilder,
  private project : ProjectService,
  private http: HttpClient,
  private toastrService: ToastrService,
  public dialogRef: MatDialogRef< AddSuiteModuleComponent>) { 
    this.url=environment.baseUrl;
    //console.log(data.message);
    //console.log(data.status);
    // if(data.status=='Update'){
    //   this.önUpdate = true;
    //   //console.log(this.önUpdate)
    // }
  
      this.önUpdate = false;
      this.onAdd = true;
      //console.log(this.önUpdate)
  
    // this.titleName = data.message.title;
    // this.description = data.message.comment;
    // //console.log(this.titleName);
    // //console.log(this.description);
  }
  ngOnInit() {
    this.loadForm();
    console.log(this.data);
    this.updateTestModuleForm = this.formBuilder.group({
      name:['',[
        Validators.required,
        Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)
    ]],
      comment:['']
    })

    this.project.isModuleSelected.subscribe((res)=>
    {
      console.log(res);
      this.isModuleSelected = res;
    })

    this.project.selectedModuleData.subscribe((res)=>
    {
      console.log(res);
      this.selectedModuleData = res;
      this.parentTestDataId = res.moduleData.items[0].parentTestDataId;
    })

  }


  loadForm(){
    this.addTestModuleForm = this.formBuilder.group({
      name:['',[
        Validators.required,
        Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/)
    ]],
      comment:['']
    })
  }
get f(){
  return this.addTestModuleForm.controls;
}
  onModuleAdd(){
    this.submitted = true;
    if(this. addTestModuleForm.invalid){
      return;
    }
    var objFormval = this.addTestModuleForm.value;

    if (! /^[^:|*?<>/\\"]+$/.test(objFormval.name)) {
      this.toastrService.clear();
      this.toastrService.warning('Suite Name is not Valid, Name cannot contain /[<>:"\/\\|?*');
      return;
    }

    this.submitDialog();

    if(this.dependent==false){
      let ValueForAdd={
      
        title: objFormval.name, 
        comment: objFormval.comment,
         projectId: this.data.message.id,
        //  parentTestDataId: this.parentTestDataId
      }

      // const ValueForAdd={
      //   dependent: "false", 
      //   title: objFormval.name, 
      //   comment: objFormval.comment,
      //    projectId: this.projectId,
      //    parentTestDataId: this.parentTestDataId
      // }

      if(this.isModuleSelected)
      {
        ValueForAdd['dependent'] =  false;
        ValueForAdd['parentTestDataId'] =  this.parentTestDataId;
      }
    
      
      //console.log(objFormval); 
      //console.log("");
      //console.log(ValueForAdd);//http://beatblipdemo.agreeya.net/HuLoopRest/huloop/test/addTestFile
      
      this.http.post(this.url + '/HuLoopRest/huloop/test/addTestFile'   ,ValueForAdd). subscribe((data) => {
        if(data) {
          this.toastrService.clear();
           this.toastrService.success( 'Process Added successfully'); 
            //console.log("projectData", data); 
            }  
       });

      

    }
else {
  const ValueForAdd={
      
    title: objFormval.name, 
    comment: objFormval.comment,
     projectId: this.data.message.id,
     dependent:"true"
    //  parentTestDataId: this.parentTestDataId
  }
 
  this.http.post(this.url + '/HuLoopRest/huloop/test/addTestFile'   ,ValueForAdd). subscribe((data) => {
    if(data) {
      this.toastrService.clear();
       this.toastrService.success( 'Suite Added successfully'); 
        //console.log("projectData", data); 
        }  
   });

}  
  }
  onModuleUpdate(){
    this.submitted = true;
    if(this. updateTestModuleForm.invalid){
      return;
    }
    var objFormval = this.updateTestModuleForm.value;

    if (! /^[^:|*?<>/\\"]+$/.test(objFormval.name)) {
      this.toastrService.clear();
      this.toastrService.warning('Suite Name is not Valid, Name cannot contain /[<>:"\/\\|?*');
      return;
    }

    this.submitDialog();
    
    if(this.dependent==false){
      const ValueForAdd={
      
        title: objFormval.name, 
        comment: objFormval.comment,
         projectId: this.data.message.id,
        //  parentTestDataId: this.parentTestDataId
      }
      //console.log(objFormval); 
      //console.log("");
      //console.log(ValueForAdd);//http://beatblipdemo.agreeya.net/HuLoopRest/huloop/test/addTestFile
      
      this.http.post(this.url + '/HuLoopRest/huloop/test/addTestFile'   ,ValueForAdd). subscribe((data) => {
        if(data) {
          this.toastrService.clear();
           this.toastrService.success( ' Suite Added successfully'); 
            //console.log("projectData", data); 
            }  
       });

      

    }
else {
  const ValueForAdd={
      
    title: objFormval.name, 
    comment: objFormval.comment,
     projectId: this.data.message.id,
     dependent:"true"
    //  parentTestDataId: this.parentTestDataId
  }
 
  this.http.post(this.url + '/HuLoopRest/huloop/test/addTestFile'   ,ValueForAdd). subscribe((data) => {
    if(data) {
      this.toastrService.clear();
       this.toastrService.success( ' Suite Added successfully'); 
        //console.log("projectData", data); 
        }  
   });

}
  }
  
  closeDialog() {
    this.dialogRef.close(false);
  }

  submitDialog() {
    this.dialogRef.close(true);
  }

  setDependent(){
    this.dependent=true;
  }
}
